import { Link } from 'react-router-dom';

/** 列表卡片所需字段（兼容 mock Service 与后端产品映射） */
export type ServiceCardModel = {
  slug: string;
  name: string;
  provider: string;
  rating: number;
  description: string;
  priceAmount: string;
  priceUnit?: string;
  rmbAmount?: string;
  options: string;
  icon: string;
  tag?: string;
  categoryName?: string;
};

interface ServiceCardProps {
  service: ServiceCardModel;
}

export default function ServiceCard({ service }: ServiceCardProps) {
  return (
    <Link
      to={`/services/${service.slug}`}
      className="block bg-white rounded-xl border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all duration-200 overflow-hidden group cursor-pointer select-none"
    >
      {/* Card Header */}
      <div className="relative bg-gray-50 p-3 pb-2">
        {service.tag && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-red-50 text-red-500 text-xs font-medium rounded-full">
            {service.tag}
          </span>
        )}
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
              <img
                src={service.icon}
                alt={service.name}
                className="w-7 h-7 object-contain"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            {service.categoryName && (
              <div className="mb-1 inline-flex max-w-full items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[11px] font-medium text-gray-500 ring-1 ring-gray-100">
                <i className="ri-price-tag-3-line text-xs text-gray-400" />
                <span className="truncate">{service.categoryName}</span>
              </div>
            )}
            <h3 className="text-sm font-bold text-gray-900 mb-0.5 group-hover:text-gray-700 transition-colors leading-tight">
              {service.name}
            </h3>
            {/* <p className="text-gray-500 text-xs">{service.provider}</p> */}
          </div>
          {/* <div className="flex items-center space-x-1 flex-shrink-0">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-amber-400 text-xs" />
            </div> */}
            {/* <span className="text-xs font-semibold text-gray-700">{service.rating}</span> */}
          {/* </div> */}
        </div>
      </div>

      {/* Card Body */}
      <div className="p-3 pt-2">
        <p className="text-gray-600 text-xs leading-relaxed mb-2 line-clamp-2">
          {service.description}
        </p>

        <div className="flex items-end justify-between mb-2">
          <div>
            <div className="flex flex-wrap items-baseline gap-x-1.5 gap-y-1">
              <span className="text-lg font-bold text-gray-900">{service.priceAmount}</span>
              <span className="text-gray-400 text-xs">{service.priceUnit || 'U'}</span>
              <span className="text-gray-400 text-xs">起</span>
              {service.rmbAmount && (
                <span className="ml-1 rounded-full bg-gray-50 px-2 py-0.5 text-sm font-semibold text-gray-600">
                  {service.rmbAmount}
                </span>
              )}
            </div>
            {/* {service.options && (
              <p className="text-gray-400 text-xs mt-0.5">{service.options}</p>
            )} */}
          </div>
        </div>

        <div className="w-full bg-gray-900 text-white py-1.5 px-3 rounded-lg hover:bg-gray-700 transition-all duration-150 text-center text-xs font-medium flex items-center justify-center space-x-1 group-hover:bg-gray-800">
          <span>查看详情</span>
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs" />
          </div>
        </div>
      </div>
    </Link>
  );
}
